import '../sass/statistics-alt.scss';
